
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';

import firebase from '@/firebase';
import store from '@/store';

export default defineComponent({
	props: {
		padding: Boolean,
	},
	setup(props) {
		const profileHover = ref(false);
		const router = useRouter();
		const newtab = (location: string) => window.open(location);
		function PHFalse() {
			setTimeout(() => {
				profileHover.value = false;
			}, 150);
		}
		return {
			profileHover,
			PHFalse,
			router,
			store,
			firebase,
			newtab,
			props,
		};
	},
});
